export const handleMailTo = ()=>{
    return window.location.href = `mailto:${process.env.REACT_APP_CONTACT_EMAIL}`
}